import React from 'react';

import { PalmettoOptionGroup, PalmettoRadioGroupProps } from '@palmetto/dsm-components';
import { trackClick } from '../../tracking/Tracking';

interface TrackingProps {
  trackingId: string;
  trackingProperties?: Record<string, unknown>;
}

export type Props = Omit<PalmettoRadioGroupProps, 'type'> & TrackingProps;

export const RadioGroup: React.FC<Props> = ({ trackingId, trackingProperties, onChange, ...restProps }: Props) => {
  const trackedOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    trackClick(trackingId, 'button', {
      value: event.target.value,
      page: window.location.href,
      ...trackingProperties,
    });
    onChange?.(event);
  };

  return <PalmettoOptionGroup type="radio" {...restProps} onChange={trackedOnChange} data-tracking-id={trackingId} />;
};
